import React, { FC } from "react";
import { Accordion, Heading, Icon, Link, List } from "@telia/teddy";
import TEXT from "../../../text-consts";

interface TermsProps {
    hasPreownedHandsetItems?: boolean;
    hasScreenOrPlusInsurance?: boolean;
    isMBB?: boolean;
}

const RegularTerms: React.FC = () => (
    <>
        {TEXT.TERMS.DESCRIPTION_1}
        <br />
        <br />
        {TEXT.TERMS.DESCRIPTION_2}
        <br />
        <br />
    </>
);

const MBBTerms: React.FC = () => (
    <>
        <Heading mb="100" as="h2" variant="title-200">
            {TEXT.TERMS.HEADING_MBB_1}
        </Heading>
        {TEXT.TERMS.DESCRIPTION_MBB_1}
        <Heading mb="100" as="h2" variant="title-100">
            {TEXT.TERMS.HEADING_MBB_2}
        </Heading>
        {TEXT.TERMS.DESCRIPTION_MBB_2}
        <Heading mb="100" as="h2" variant="title-100">
            {TEXT.TERMS.HEADING_MBB_3}
        </Heading>
        {TEXT.TERMS.DESCRIPTION_MBB_3}
        <br />
        <br />
    </>
);

const Terms: FC<TermsProps> = ({ hasPreownedHandsetItems, hasScreenOrPlusInsurance, isMBB = false }) => {
    const accordionsItems = [
        {
            id: "accordian-item-terms",
            title: `${TEXT.TERMS.HEADING}`,
            children: (
                <>
                    {isMBB ? <MBBTerms /> : <RegularTerms />}
                    <List layout="vertical" gapSize="small">
                        <List.Item>
                            <List.Illustration variant="image">
                                <Icon name="chevron-right" aria-hidden="true" />
                            </List.Illustration>
                            <List.Content>
                                <Link variant="text" href="https://www.telia.no/hastighet">
                                    {TEXT.TERMS.DESCRIPTION_4}
                                </Link>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <List.Illustration variant="image">
                                <Icon name="chevron-right" aria-hidden="true" />
                            </List.Illustration>
                            <List.Content>
                                <Link
                                    variant="text"
                                    href="https://www.telia.no/globalassets/pdf/vilkar/telias-brukervilkar-for-privatpersoner.pdf"
                                >
                                    {TEXT.TERMS.DESCRIPTION_5}
                                </Link>
                            </List.Content>
                        </List.Item>
                        {hasScreenOrPlusInsurance && !hasPreownedHandsetItems && (
                            <List.Item>
                                <List.Illustration variant="image">
                                    <Icon name="chevron-right" aria-hidden="true" />
                                </List.Illustration>
                                <List.Content>
                                    <Link
                                        variant="text"
                                        href="https://www.telia.no/globalassets/pdf/vilkar/vilkar-telia-skjermforsikring-telia-plussforsikring.pdf"
                                    >
                                        {TEXT.TERMS.DESCRIPTION_9}
                                    </Link>
                                </List.Content>
                            </List.Item>
                        )}
                        {hasScreenOrPlusInsurance && hasPreownedHandsetItems && (
                            <List.Item>
                                <List.Illustration variant="image">
                                    <Icon name="chevron-right" aria-hidden="true" />
                                </List.Illustration>
                                <List.Content>
                                    <Link
                                        variant="text"
                                        href="https://www.telia.no/globalassets/pdf/forsikring/wtw/telia-vilkar-like-fin-skjerm-og-pluss-forsikring.pdf"
                                    >
                                        {TEXT.TERMS.DESCRIPTION_10}
                                    </Link>
                                </List.Content>
                            </List.Item>
                        )}
                    </List>
                </>
            ),
        },
        {
            id: "accordian-item-right-of-withdrawal",
            title: `${TEXT.WITHDRAWAL_RIGHT.HEADING}`,
            children: (
                <>
                    {TEXT.WITHDRAWAL_RIGHT.DESCRIPTION_1}
                    <br />
                    {TEXT.WITHDRAWAL_RIGHT.DESCRIPTION_2}
                    <br />
                    <br />
                    <List layout="vertical" gapSize="small">
                        <List.Item>
                            <List.Illustration variant="image">
                                <Icon name="chevron-right" aria-hidden="true" />
                            </List.Illustration>
                            <List.Content>
                                <Link
                                    variant="text"
                                    href="https://www.telia.no/kundeservice/vilkar-og-angrerett/#angrerett"
                                >
                                    {TEXT.WITHDRAWAL_RIGHT.DESCRIPTION_3}
                                </Link>
                            </List.Content>
                        </List.Item>
                    </List>
                </>
            ),
        },
    ];

    return (
        <Accordion type="multiple">
            {accordionsItems.map((item) => (
                <Accordion.Item key={item.title} value={item.title}>
                    <Accordion.Header>
                        <Accordion.Trigger>{item.title}</Accordion.Trigger>
                    </Accordion.Header>
                    <Accordion.Content>{item.children}</Accordion.Content>
                </Accordion.Item>
            ))}
        </Accordion>
    );
};

export default Terms;
